import React from "react";
import BaseInfoIcon from "../../../icons/base-info.icon";
import styles from "./index.module.scss";

const BannerInfo = () => {
  return (
    <div className={styles.banner}>
      <div className={styles.iconWrapper}>
        <BaseInfoIcon width={15} height={15} />
      </div>

      <p className={styles.text}>
        This Plans Prices are controlled by HighGround
      </p>
    </div>
  );
};

export default BannerInfo;
